import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

const internalCategoryFormSchema = z.object({
  name: z.string('Veuillez renseigner un nom de catégorie interne.').min(1).max(60),
  productIds: z.array(z.number()).optional(),
})

export type InternalCategoryForm = z.infer<typeof internalCategoryFormSchema>

// Form hook
export const useInternalCategoryForm = (defaultValues?: Partial<InternalCategoryForm>) => {
  const form = useForm<InternalCategoryForm>({
    defaultValues: {
      ...defaultValues,
    },
    resolver: zodResolver(internalCategoryFormSchema),
  })

  return form
}
